import { TokenPocket } from 'ual-token-pocket'
import { Anchor } from 'ual-anchor'

export const rpcEndpoint = `${process.env.REACT_APP_WAX_API_PROTOCOL}://${
  process.env.REACT_APP_WAX_API_HOST
}${process.env.REACT_APP_WAX_API_PORT ? ':' : ''}${
  process.env.REACT_APP_WAX_API_PORT
}`
export const appName = process.env.REACT_APP_WAX_APP_NAME || 'app'
export const network = {
  chainId: process.env.REACT_APP_WAX_CHAIN_ID,
  rpcEndpoints: [
    {
      protocol: process.env.REACT_APP_WAX_API_PROTOCOL,
      host: process.env.REACT_APP_WAX_API_HOST,
      port: parseInt(process.env.REACT_APP_WAX_API_PORT)
    }
  ]
}
export const authenticators = [
  new TokenPocket([network]),
  new Anchor([network], { appName })
]
